// vue components  列表数据字段名对应 Remark
const home = import('../views/workorder.vue'); //主页

function look(n) {
  switch (n) {
    case 'home':
      return home
      break;

    default:
      return home
      break;
  }
}

export default (name) => () => look(name);



// WEBPACK FOOTER //
// ./src/modules/workorder/utils/lazyLoading.js